import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Navbar, NavDropdown, Nav, Container, Form, Row, Col } from "react-bootstrap";
import LoggedInUser from "./LoggedInUser";
import SearchBar from "./SearchBar";
import SearchBarAdvisor from "./SearchBarAdvisor";
import image from "../../images/logo.png";

interface TopNavBarProps
{
    title: string;
    homeId?: string;
    page?: string;
    role?: string;
}

class TopNavBar extends React.Component<TopNavBarProps>
{
    render()
    {
        let homeID = "about";

        if (this.props.role == "student")
            homeID = "accessLog";

        return <Navbar bg={"light"} expand="md" aria-label="Top Navigation Bar">
            <Container>
                <Navbar.Brand href={"#/" + homeID}>
                    <img
                        src={image}
                        width="30"
                        alt={'logo'}
                        height="30"
                        className="d-inline-block align-top" />
                    <span className={"ml-2"}>{this.props.title}</span>
                </Navbar.Brand>
                <Nav id="content-mobile" className={"nav-help"} aria-label="help">
                    <NavDropdown id={"top-navbar-nav"} className="border-left border-right" title={<i className="fas fa-question-circle" style={{ color: "white" }}></i>}>
                        <NavDropdown.Item href="http://student.mit.edu/" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> WebSIS</NavDropdown.Item>
                        <NavDropdown.Item href="https://registration.mit.edu/onlinereg" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Online Registrations</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwsdau.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Degree Audit</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwsgrd.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Grade Audit</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwssor.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Status of Registration</NavDropdown.Item>
                        <NavDropdown.Item href="http://web.mit.edu/registrar/records/certs/enrollment.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Enrollment Certification</NavDropdown.Item>
                        <NavDropdown.Item href="http://web.mit.edu/registrar/records/certs/subject.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Subject Registration Letter</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-docs/sohwsreq.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Order Official Transripts</NavDropdown.Item>
                    </NavDropdown>
                </Nav>
                <Navbar.Text id="content-mobile" as={"div"} className="pl-3 nav-user"><LoggedInUser /></Navbar.Text>
                <Form inline className={"nav-items-right"}>
                    {
                        (this.props.role != "student")
                            ?
                            this.props.page != "search"
                                ?
                                <div className="typeahead ml-3 mr-3 nav-search">
                                    {
                                        this.props.role == "academicAdvisor"
                                            ?
                                            <SearchBarAdvisor isTopBar={true} />
                                            :
                                            <SearchBar />
                                    }
                                </div>
                                :
                                <div></div>
                            :
                            <div></div>
                    }
                </Form>
                <Nav id="content-desktop" className={"nav-help"} aria-label="help">
                    <NavDropdown id={"top-navbar-nav"} className="border-left border-right" title={<i className="fas fa-question-circle" style={{ color: "white" }}></i>}>
                        <NavDropdown.Item href="http://student.mit.edu/" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> WebSIS</NavDropdown.Item>
                        <NavDropdown.Item href="https://registration.mit.edu/onlinereg" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Online Registrations</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwsdau.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Degree Audit</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwsgrd.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Grade Audit</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-bin/shrwssor.sh" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Status of Registration</NavDropdown.Item>
                        <NavDropdown.Item href="http://web.mit.edu/registrar/records/certs/enrollment.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Enrollment Certification</NavDropdown.Item>
                        <NavDropdown.Item href="http://web.mit.edu/registrar/records/certs/subject.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Subject Registration Letter</NavDropdown.Item>
                        <NavDropdown.Item href="https://student.mit.edu/cgi-docs/sohwsreq.html" target="_blank"><i className={"fas fa-question-circle"} style={{ color: "grey", opacity: 0.4 }}></i> Order Official Transripts</NavDropdown.Item>
                    </NavDropdown>
                </Nav>
                <Navbar.Text id="content-desktop" as={"div"} className="pl-3 nav-user"><LoggedInUser /></Navbar.Text>
            </Container>
        </Navbar>;
    }
}

const mapStateToProps = (state: any) => ({
    page: state.app.page,
    role: state.app.user.role
});

export default connect(mapStateToProps)(TopNavBar);